import type { Observable } from 'rxjs';
import type { DomainCheckRequest, DomainCheckSuccessResponse } from '@common/types/domain.type';

import { Injectable } from '@angular/core';

import { BaseHttpService } from '@common/services/REST/base.http.service';

@Injectable({
    providedIn: 'root',
})
export class ValidatorHttpService extends BaseHttpService {
    public checkDomain(domainRequest: DomainCheckRequest): Observable<DomainCheckSuccessResponse> {
        return this.http.post<DomainCheckSuccessResponse>(this.formatApiUrl('domains/check'), domainRequest);
    }

    public checkSiteDomain(siteId: string, domain: string): Observable<any> {
        return this.http.post<any>(this.formatApiUrl(`sites/${siteId}/domains/check`), { domain });
    }

    public checkPageUrl(siteId: string, url: string): Observable<any> {
        return this.http.post<any>(this.formatApiUrl(`sites/${siteId}/pages/check`), { url });
    }

    public checkPageName(siteId: string, name: string): Observable<any> {
        return this.http.post<any>(this.formatApiUrl(`sites/${siteId}/pages/check`), { name });
    }
}
